import { render, staticRenderFns } from "./porposal-edit.vue?vue&type=template&id=c6055de6&scoped=true&"
import script from "./porposal-edit.vue?vue&type=script&lang=ts&"
export * from "./porposal-edit.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-edit.vue?vue&type=style&index=0&id=c6055de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6055de6",
  null
  
)

export default component.exports